import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownTransferServices', request)
}

async function post(request) {
    return await postMethod('/api/ownTransferServices', request)
}

async function put(request) {
    return await putMethod('/api/ownTransferServices', request)
}

export {get, post, put}
